"use client";

import { useCallback } from "react";

import { useCurrency } from "@/hooks/use-currency";
import { useDateTime } from "@/hooks/use-datetime";
import { formatValue } from "@/lib/format-value";

import type { ValueFormat } from "@/types";

/**
 * `formatValue` with the company's currency and timezone already bound.
 *
 * Every widget value goes through here, so a renderer never has to know whether
 * it's holding money, a percentage or a month — the backend said which, and this
 * resolves it against the account's own settings.
 */
export function useValueFormat() {
  const { format: money } = useCurrency();
  const dt = useDateTime();

  return useCallback(
    (value: number | string | null | undefined, format: ValueFormat) =>
      formatValue(value, format, {
        money,
        date: (raw, options) => dt.format(raw, options),
      }),
    [money, dt],
  );
}
